// extracted by mini-css-extract-plugin
module.exports = {"BuyDetailsContainer":"BuyDetails_BuyDetailsContainer__3QNAA","title":"BuyDetails_title__2KIzE","text":"BuyDetails_text__10E8v"};